import './_ctx/init';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { routes } from './routes';

const router = createBrowserRouter(routes);

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  ),
);
